import moment from 'moment'

import 'moment/locale/tr'
import 'moment/locale/ar-sa'
import 'moment/locale/de'
import 'moment/locale/es'
import 'moment/locale/fa'
import 'moment/locale/fr'
import 'moment/locale/ru'
import 'moment/locale/uk'
import 'moment/locale/zh-cn'

const momentLanguageImport = (language?: string): void => {
  if (language) {
    if (language) {
      let langCode = ''

      if (language !== 'zh-cn' && language !== 'ar-sa') {
        langCode = language.split('-')[0].toLowerCase()
      } else langCode = language

      const availableLocales = moment.locales()

      if (availableLocales.includes(langCode)) {
        moment.locale(langCode)
      } else {
        if (langCode !== 'appspecific') {
          console.warn(
            `Moment locale "${langCode}" is not available. Check your imports`,
          )
        }

        moment.locale('en')
      }
    } else {
      moment.locale('en')
    }
  }
}

export default momentLanguageImport
